package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val SuccessContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(top = 30.px, bottom = 30.px, leftRight = 20.px)
    }
    Breakpoint.MD {
        Modifier.padding(top = 60.px, bottom = 60.px, leftRight = 40.px)
    }
    Breakpoint.LG {
        Modifier
            .width(700.px)
            .padding(top = 80.px, bottom = 80.px, leftRight = 0.px)
    }
}

val SuccessTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(22.px)
            .margin(bottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(28.px)
            .margin(bottom = 15.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(38.px)
    }
}

val SuccessSubtitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(13.px)
            .margin(bottom = 20.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(16.px)
            .margin(bottom = 25.px)
    }
    Breakpoint.LG {
        Modifier
            .fontSize(20.px)
            .margin(bottom = 30.px)
    }
}

val SuccessCardContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .borderRadius(20.px)
            .padding(16.px)
            .margin(bottom = 20.px)
    }
    Breakpoint.MD {
        Modifier
            .width(480.px)
            .borderRadius(32.px)
            .padding(24.px)
            .margin(bottom = 28.px)
    }
    Breakpoint.LG {
        Modifier
            .width(820.px)
            .padding(32.px)
            .margin(bottom = 40.px)
    }
}

val SuccessCardTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(15.px)
            .margin(bottom = 12.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(17.px)
            .margin(bottom = 18.px)
    }
    Breakpoint.LG {
        Modifier
            .fontSize(23.px)
            .margin(bottom = 26.px)
    }
}

val SuccessActionButtonStyle = CssStyle {
    base {
        Modifier
            .width(200.px)
            .height(46.px)
            .fontSize(14.px)
            .margin(bottom = 12.px)
    }
    Breakpoint.MD {
        Modifier
            .width(350.px)
            .height(56.px)
            .fontSize(18.px)
            .margin(bottom = 16.px)
    }
    Breakpoint.LG {
        Modifier
            .width(570.px)
            .height(62.px)
            .fontSize(25.px)
    }
}

val SuccessSecondaryButtonStyle = CssStyle {
    base {
        Modifier
            .width(200.px)
            .height(46.px)
            .fontSize(14.px)
    }
    Breakpoint.MD {
        Modifier
            .width(350.px)
            .height(52.px)
            .fontSize(18.px)
    }
    Breakpoint.LG {
        Modifier
            .width(570.px)
            .height(60.px)
            .fontSize(25.px)
    }
}

val SuccessIconStyle = CssStyle {
    base {
        Modifier
            .fontSize(18.px)
            .margin(right = 6.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(25.px)
            .margin(right = 10.px)
    }
}

val TransactionRowPaddingStyle = CssStyle {
    base { Modifier.padding(topBottom = 12.px) }
    Breakpoint.MD { Modifier.padding(topBottom = 16.px) }
    Breakpoint.LG { Modifier.padding(topBottom = 20.px) }
}

val TransactionTextResponsiveStyle = CssStyle {
    base { Modifier.fontSize(12.px) }
    Breakpoint.MD { Modifier.fontSize(15.px) }
    Breakpoint.LG { Modifier.fontSize(20.px) }
}

val TransactionDateGapStyle = CssStyle {
    base { Modifier.gap(6.px) }
    Breakpoint.MD { Modifier.gap(12.px) }
}

val TransactionPaymentModeGapStyle = CssStyle {
    base { Modifier.gap(10.px) }
    Breakpoint.MD { Modifier.gap(55.px) }
}

val TransactionPhoneTextStyle = CssStyle {
    base { Modifier.fontSize(13.px) }
    Breakpoint.MD { Modifier.fontSize(20.px) }
}

val TransactionProviderImageStyle = CssStyle {
    base {
        Modifier
            .width(50.px)
            .height(22.px)
    }
    Breakpoint.MD {
        Modifier
            .width(80.px)
            .height(30.px)
    }
    Breakpoint.LG {
        Modifier
            .width(120.px)
            .height(40.px)
    }
}